import $ from 'jquery'
import enquire from 'enquire.js'

import DesktopHeader from './GlobalHeader--Desktop'
import MobileHeader from './GlobalHeader--Mobile'

export default class GlobalNav{
  constructor($el) {
    const resetNav = this.resetNav
    enquire.register('screen and (max-width:1001px)', {
      match() {
        resetNav()
        new MobileHeader($el)
      },
      unmatch() {
        resetNav()
        new DesktopHeader($el)
      },
      setup() {
        new DesktopHeader($el)
      },
    })
    $(document).on('click','.st-clear',function() {
      $('.search-container.active').removeClass('active')
    })

    // Set Preferred Language Cookie
    $('.global-header__utility [hreflang]').click( function(e) {
      document.cookie = 'preferred_lang=' + e.currentTarget.hreflang + '; path=/;'
    })
    
  }
  resetNav() {
    $('body').removeClass('navigation-open flyout--open')
    $('.global-header__bottom').removeClass('submenu-open')
    $('.flyout').removeClass('active')
    $('.global-header__burger').removeClass('is-active')
    $('.global-header__nav, .global-header__nav *, .global-header__burger, .parent-link')
      .unbind()
  }
}
